import request from '@/utils/request'

// 考试管理API
export const examApi = {
  // 获取课程下的考试列表
  getExamsByCourse(courseId) {
    return request({
      url: `/exam/course/${courseId}`,
      method: 'get'
    })
  },

  // 获取未归档的考试列表
  getUnarchivedExams(courseId) {
    return request({
      url: `/exam/course/${courseId}/unarchived`,
      method: 'get'
    })
  },

  // 获取未归档的考试列表（包含当前使用试卷信息）
  getUnarchivedExamsWithActivePaper(courseId) {
    return request({
      url: `/exam/course/${courseId}/unarchived-with-paper`,
      method: 'get'
    })
  },

  // 获取归档考试列表
  getHistoryExams(courseId) {
    return request({
      url: `/exam/course/${courseId}/history`,
      method: 'get'
    })
  },

  // 获取未批阅的考试列表
  getUngradedExams(courseId) {
    return request({
      url: `/exam/course/${courseId}/ungraded`,
      method: 'get'
    })
  },

  // 创建考试
  createExam(data) {
    return request({
      url: '/exam',
      method: 'post',
      data
    })
  },

  // 更新考试
  updateExam(id, data) {
    return request({
      url: `/exam/${id}`,
      method: 'put',
      data
    })
  },

  // 删除考试
  deleteExam(id) {
    return request({
      url: `/exam/${id}`,
      method: 'delete'
    })
  },

  // 归档考试
  archiveExam(id) {
    return request({
      url: `/exam/${id}/archive`,
      method: 'put'
    })
  },

  // 取消归档考试
  unarchiveExam(id) {
    return request({
      url: `/exam/${id}/unarchive`,
      method: 'put'
    })
  },

  // 更新考试归档设置
  updateArchiveSettings(id, settings) {
    return request({
      url: `/exam/${id}/archive-settings`,
      method: 'put',
      data: settings
    })
  },

  // 获取考试的试卷列表
  getExamPapers(examId) {
    return request({
      url: `/exam/${examId}/papers`,
      method: 'get'
    })
  },

// 创建试卷
createPaper(examId, paperCode, paperName) {
  return request({
    url: `/exam/${examId}/papers`,
    method: 'post',
    data: { paperCode, paperName }
  })
},

// 删除试卷
deletePaper(paperId) {
  return request({
    url: `/exam/paper/${paperId}`,
    method: 'delete'
  })
},

// 设置试卷为当前使用试卷
setActivePaper(paperId) {
  return request({
    url: `/exam/paper/${paperId}/active`,
    method: 'put'
  })
},

// 获取考试的班级ID列表
getExamClassIds(examId) {
  return request({
    url: `/exam/${examId}/classes`,
    method: 'get'
  })
},

// 保存考试的班级关联
saveExamClasses(examId, classIds) {
  return request({
    url: `/exam/${examId}/classes`,
    method: 'post',
    data: { classIds }
  })
},

  // 获取试卷题目
  getPaperQuestions(paperId) {
    return request({
      url: `/exam/paper/${paperId}/questions`,
      method: 'get'
    })
  },

  // 添加题目到试卷
  addQuestionsToPaper(paperId, questionIds) {
    return request({
      url: `/exam/paper/${paperId}/questions`,
      method: 'post',
      data: { questionIds }
    })
  },

  // 从试卷移除题目
  removeQuestionFromPaper(paperId, questionId) {
    return request({
      url: `/exam/paper/${paperId}/question/${questionId}`,
      method: 'delete'
    })
  },

  // 移动题目
  moveQuestion(paperId, questionId, direction) {
    return request({
      url: `/exam/paper/${paperId}/question/${questionId}/move`,
      method: 'put',
      data: { direction }
    })
  },

  // 更新题目分值
  updateQuestionScore(paperId, questionId, score) {
    return request({
      url: `/exam/paper/${paperId}/question/${questionId}/score`,
      method: 'put',
      data: { score }
    })
  },

  // 保存试卷
  savePaper(paperId, questions) {
    return request({
      url: `/exam/paper/${paperId}`,
      method: 'put',
      data: { questions }
    })
  },

  // 随机组卷
  randomGeneratePaper(paperId, config) {
    return request({
      url: `/exam/paper/${paperId}/random`,
      method: 'post',
      data: config
    })
  },

  // 获取考试学生列表
  getExamStudents(examId) {
    return request({
      url: `/exam/${examId}/students`,
      method: 'get'
    })
  },

  // 单个试卷上传
  uploadSingle(data) {
    return request({
      url: '/exam/upload-single',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 批量试卷上传
  uploadBatch(data) {
    return request({
      url: '/exam/upload-batch',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 确认AI识别结果
  confirmAIRecognition(scanId) {
    return request({
      url: `/exam/scan/${scanId}/confirm`,
      method: 'put'
    })
  },

  // 修正AI识别信息
  correctAIRecognition(scanId, data) {
    return request({
      url: `/exam/scan/${scanId}/correct`,
      method: 'put',
      data
    })
  },

  // 拒绝AI识别结果
  rejectAIRecognition(scanId) {
    return request({
      url: `/exam/scan/${scanId}/reject`,
      method: 'put'
    })
  },

  // 获取第一个未批阅的学生
  getFirstUngradedStudent(examId) {
    return request({
      url: `/exam/${examId}/grading/first`,
      method: 'get'
    })
  },

  // 获取下一个未批阅的学生
  getNextUngradedStudent(examId, currentStudentId) {
    return request({
      url: `/exam/${examId}/grading/next/${currentStudentId}`,
      method: 'get'
    })
  },

  // 获取上一个学生
  getPrevStudent(examId, currentStudentId) {
    return request({
      url: `/exam/${examId}/grading/prev/${currentStudentId}`,
      method: 'get'
    })
  },

  // 获取学生题目列表
  getStudentQuestions(examId, studentId) {
    return request({
      url: `/exam/${examId}/student/${studentId}/questions`,
      method: 'get'
    })
  },

  // 获取AI分析结果
  getAIAnalysis(examId, studentId) {
    return request({
      url: `/exam/${examId}/student/${studentId}/ai-analysis`,
      method: 'get'
    })
  },

  // 获取批阅标注
  getAnnotations(examId, studentId) {
    return request({
      url: `/exam/${examId}/student/${studentId}/annotations`,
      method: 'get'
    })
  },

  // 保存批阅
  saveGrading(data) {
    return request({
      url: '/exam/grading/save',
      method: 'post',
      data
    })
  },

  // 完成批阅
  completeGrading(examId, studentId) {
    return request({
      url: `/exam/${examId}/student/${studentId}/complete`,
      method: 'put'
    })
  },

  // 更新题目得分
  updateQuestionScore(examId, studentId, questionId, score) {
    return request({
      url: `/exam/${examId}/student/${studentId}/question/${questionId}/score`,
      method: 'put',
      data: { score }
    })
  },

  // 获取考试学生成绩
  getExamStudentScores(examId, params) {
    return request({
      url: `/exam/${examId}/scores`,
      method: 'get',
      params
    })
  },

  // 获取学生答题详情
  getStudentAnswerDetails(examId, studentId) {
    return request({
      url: `/exam/${examId}/student/${studentId}/answers`,
      method: 'get'
    })
  },

  // 获取批阅标注
  getGradingAnnotations(examId, studentId) {
    return request({
      url: `/exam/${examId}/student/${studentId}/grading-annotations`,
      method: 'get'
    })
  },

  // 导出考试成绩
  exportExamScores(examId, filters) {
    return request({
      url: `/exam/${examId}/export-scores`,
      method: 'post',
      data: filters,
      responseType: 'blob'
    })
  },

  // 同步所有考试的试卷套数
  syncAllExamPaperCounts() {
    return request({
      url: '/exam/sync-paper-counts',
      method: 'post'
    })
  },

  // 获取考试基本信息（通过课程考试列表获取）
  getExamById(courseId, examId) {
    return request({
      url: `/exam/course/${courseId}`,
      method: 'get'
    }).then(response => {
      if (response && response.code === 1 && response.data) {
        const exam = response.data.find(e => e.id === examId)
        if (exam) {
          return { ...response, data: exam }
        } else {
          throw new Error('考试不存在')
        }
      }
      return response
    })
  },

  // 获取考试详情（兼容旧接口）
  getExamDetail(examId) {
    // 由于后端没有直接的GET /exam/{examId}接口，我们返回一个模拟的响应
    // 或者可以尝试通过其他方式获取考试信息
    return Promise.resolve({
      code: 1,
      data: {
        id: examId,
        examName: '考试详情',
        examDescription: '考试描述',
        totalScore: 100,
        duration: 120,
        startTime: new Date().toISOString(),
        endTime: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString()
      }
    })
  },

  // 获取学生考试详情（包含答题情况、得分、评语等）
  getStudentExamDetail(examId, studentId) {
    return request({
      url: `/exam/${examId}/student/${studentId}/detail`,
      method: 'get'
    })
  },

  // 获取考试统计数据
  getExamStatistics(courseId) {
    return request({
      url: `/exam/course/${courseId}/statistics`,
      method: 'get'
    })
  }
}
